import apiService from "./apiService";
import AppConstants from "../appConstants";

class NewsService {

    sendNews(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_SEND_NEWS, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    sendYoutube(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_SEND_YOUTUBE, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getNewsDetail(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_NEWS_GET_DETAIL}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    manageNews(params, options) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_MANAGE_NEWS, params, options)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    manageNewsReduced(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_MANAGE_NEWS_REDUCED, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateStatusEditing(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_UPDATE_STATUS_EDITING, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    cancelEditing(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_CANCEL_EDITING, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    downloadDocumentFile(id, params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(`${AppConstants.URL_NEWS_DOWNLOAD_DOCUMENT}/${id}`, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    readDocumentFile(id, params) {
        return new Promise((resolve, reject) => {
            apiService.readFile(`${AppConstants.URL_NEWS_READ_DOCUMENT}/${id}`, params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getEventStatusWithStatistic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_EVENT_STATUS_STATISTIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    scheduleNews(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_SCHEDULE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    publishNews(id, params) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_NEWS_PUBLISH}/${id}`, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    cancelNews(id, params) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_NEWS_CANCEL}/${id}`, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    disableNews(id, params) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_NEWS_DISABLE}/${id}`, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteAllDraftNews(params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_DELETE_ALL_DRAFTS, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    reIndexNews(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_RE_INDEX, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    recalculateNewsRelevance(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_RECALCULATE_RELEVANCE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    refreshNewsElastic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_REFRESH_ELASTIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    removeFromElasticsearch(params) {
        return new Promise((resolve, reject) => {
            apiService.delete(AppConstants.URL_NEWS_REMOVE_FROM_ELASTIC, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    restoreToElasticsearch(params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_RESTORE_TO_ELASTIC, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteUserTemplate(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_DELETE_USER_TEMPLATE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    vectorizeNews(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_VECTORIZE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getProcessingStatus(id) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_NEWS_PROCESSING_STATUS}/${id}/processing-status`)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    forceRetryProcessingStatus(id, body) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_NEWS_PROCESSING_STATUS_RETRY}/${id}/processing-status/retry`, body)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    synchronizeNews(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_SYNCHRONIZE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    synchronizeNewsRange(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_SYNCHRONIZE_RANGE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // Sync e reconciliacao com o Elasticsearch rodam em segundo plano: retornam { jobId } para acompanhar o progresso
    startElasticSyncJob(form) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_SYNC_ELASTIC_JOB, form, new URLSearchParams())
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    startElasticReconcileJob(form) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_RECONCILE_ELASTIC, form, new URLSearchParams())
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getElasticSyncJob(jobId) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_NEWS_SYNC_ELASTIC_JOB}/${jobId}`, new URLSearchParams())
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    getDetailUserCore(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_NEWS_DETAIL_USER_CORE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    mdtpProviderStatusAll(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_MDTP_PROVIDER_STATUS_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    mdtpProviderJwtResend(body, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_MDTP_PROVIDER_STATUS_JWT_RESEND, body, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================


    sendImportedCalendarEvents(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_SEND_IMPORTED_CALENDAR_EVENTS, form, params, true)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    checkEventConflicts(params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CHECK_EVENT_CONFLICTS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================

    syncNewsWithVectorization(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_SYNC_WITH_VECTORIZATION, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getVectorizationSyncJob(jobId, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_NEWS_SYNC_WITH_VECTORIZATION}/${jobId}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    translateNews(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_TRANSLATE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiEditBody(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_EDIT_BODY, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiSuggestions(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_SUGGESTIONS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiTagsSuggestions(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_TAGS_SUGGESTIONS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiHatSuggestions(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_HAT_SUGGESTIONS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiTitleSuggestions(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_TITLE_SUGGESTIONS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiSummarySuggestions(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_SUMMARY_SUGGESTIONS, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiBodyCreate(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_BODY_CREATE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    aiBodyImprove(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_NEWS_AI_BODY_IMPROVE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    sanitizePdfContent(id, params) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_NEWS_GET_DETAIL}/${id}/sanitize-pdf`, {}, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new NewsService();
